import {cpsUrl} from 'config/base'
import {ENDPOINT} from 'config/path'
import {type NavigateFunction} from 'react-router-dom'
import {getUserInfo, getUserInfoNew} from 'services/login.service'

const isLoggedIn = () => localStorage.getItem('isLoggedIn')?.toLowerCase().includes('true')

const isNewLogin = () => localStorage.getItem('NewLogin')?.toLowerCase().includes('true')

const NavigateLogin = (navigate) => {
    isNewLogin() ? navigate(ENDPOINT.login, {replace: true}) : (window.location.href = `${cpsUrl}/lmsweb/signon.jsp`)
}

// Function used to validate the token whether it is valid or expired
const validateToken = async () => {
    const token = localStorage.getItem('access_token')
    if (!token) {
        return false
    }
    try {
        if (localStorage.getItem('NewLogin') === 'true') {
            await getUserInfoNew(token)
            return true
        } else {
            await getUserInfo(token)
            return true
        }
    } catch (error: any) {
        throw new Error(error)
    }
}

/**
 * handleUserNavigation - Used to handle the navigation based on conditional parameters
 * @param navigate - The NavigateFunction from the useNavigate hook in React
 * @param userDetails (Optional parameter) - The user details after the login
 * @param paramValue (Optional parameter) - Custom parameter for conditional routing
 */
const handleUserNavigation = (
    navigate: NavigateFunction,
    userDetails?: Record<string, any>,
    paramValue?: string | undefined | null
) => {
    if (!userDetails) return navigate(ENDPOINT.homepage)

    const isUserLoggedIn = localStorage.getItem('isLoggedIn')
    const {
        branchAdmin = false,
        branchUser = false,
        branchSuperUser = false,
        isCarrierAdmin = false,
        isCarrierUser = false,
        isGuestUser = false
    } = userDetails.securityParams

    const branchAccess = branchAdmin || branchUser || branchSuperUser
    const carrierAccess = isCarrierAdmin || isCarrierUser

    if (isUserLoggedIn) {
        if (paramValue) {
            const isLMSWeb = ENDPOINT[paramValue].includes('lmsweb')

            if (isLMSWeb) {
                window.location.href = `${cpsUrl}${ENDPOINT[paramValue]}`
            } else return navigate(ENDPOINT[paramValue])
        } else if (branchAccess) return navigate(ENDPOINT.ff_opsDashboard)
        else if (carrierAccess) return navigate(ENDPOINT.ac_opsDashboard)
        else if (isGuestUser) return navigate(ENDPOINT.guest_dashboard)
        else return navigate(ENDPOINT.dashboard)
    }
}

export {NavigateLogin, handleUserNavigation, isLoggedIn, isNewLogin, validateToken}
